import type { ThemeConfig } from 'antd/es/config-provider/context';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#ff6105',
    fontFamily: '"Poppins", sans-serif',
    borderRadius: 4,
    colorBorder: '#CFD2D4',
    colorText: '#112227',
    colorLink: '#ff6105',
    colorLinkHover: '#db500b',
    fontSize: 14,
    colorWarningBgHover: '#db500b',
    colorInfoBgHover: '#db500b'
  }
};
